var _Circle, _Circle2, _Circle3, _Line, _Line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Line } from "react-native-svg";
var SvgShare2 = function SvgShare2(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-share-2"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 18,
    cy: 5,
    r: 3
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 6,
    cy: 12,
    r: 3
  })), _Circle3 || (_Circle3 = /*#__PURE__*/React.createElement(Circle, {
    cx: 18,
    cy: 19,
    r: 3
  })), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 8.59,
    y1: 13.51,
    x2: 15.42,
    y2: 17.49
  })), _Line2 || (_Line2 = /*#__PURE__*/React.createElement(Line, {
    x1: 15.41,
    y1: 6.51,
    x2: 8.59,
    y2: 10.49
  })));
};
export default SvgShare2;